import EtablissementLogo from '@/generated/controls/etablissement/EtablissementLogo.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: EtablissementLogo
})
